// src/components/SEO.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "College Aggregator - Find Best Colleges in Dehradun", 
  description = "Discover top colleges in Dehradun...",
  keywords = "colleges in dehradun...",
  canonical = "/",  // ✅ Relative path
  ogImage = "/images/og-image.jpg",
  ogType = "website",
  structuredData,
  noindex = false 
}) => {
  const siteUrl = "https://www.collegeaggregator.com";
  const fullCanonical = `${siteUrl}${canonical}`; // ✅ Build full URL

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* ✅ CANONICAL TAG */}
      <link rel="canonical" href={fullCanonical} />
      
      {noindex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <meta name="robots" content="index,follow" />
      )}

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
